'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        tooltipBackground: {
            type: String,
            kComposite: 'tooltip.background'
        },
        tooltipBorderColor: {
            type: String,
            kComposite: 'tooltip.border.color'
        },
        tooltipBorderWidth: {
            type: Number,
            kComposite: 'tooltip.border.width'
        },
        tooltipColor: {
            type: String,
            kComposite: 'tooltip.color'
        },
        tooltipFont: {
            type: String,
            kComposite: 'tooltip.font'
        },
        tooltipFormat: {
            type: String,
            kComposite: 'tooltip.format'
        },
        tooltipOpacity: {
            type: Number,
            kComposite: 'tooltip.opacity'
        },
        tooltipPadding: {
            type: Number,
            kComposite: 'tooltip.padding'
        },
        tooltipPaddingBottom: {
            type: Number,
            kComposite: 'tooltip.padding.bottom'
        },
        tooltipPaddingLeft: {
            type: Number,
            kComposite: 'tooltip.padding.left'
        },
        tooltipPaddingRight: {
            type: Number,
            kComposite: 'tooltip.padding.right'
        },
        tooltipPaddingTop: {
            type: Number,
            kComposite: 'tooltip.padding.top'
        },
        tooltipShared: {
            type: Boolean,
            kComposite: 'tooltip.shared'
        },
        tooltipSharedTemplate: {
            type: String | Function,
            kComposite: 'tooltip.sharedTemplate'
        },
        tooltipTemplate: {
            type: String | Function,
            kComposite: 'tooltip.template'
        },
        tooltipVisible: {
            type: Boolean,
            kComposite: 'tooltip.visible'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts-vue-wrapper/dist/es/KendoChartBase/Tooltip.js
// module id = 689
// module chunks = 0